<template>
    <v-app light>
        <v-content>
        <main-nav 
            :isAuth="isAuth" 
            :menuItems="menuItems" 
            v-on:logout="onLogout"            
        ></main-nav> 
        <message-bar></message-bar>
            <v-container fluid v-scroll="onScroll" class="pa-0">                
                    <transition name="fade">
                        <v-btn
                            fixed
                            dark
                            fab
                            bottom
                            class="mt-5 darken-2"
                            right
                            color="black"
                            v-if="offsetTop >=200"
                            v-on:click.native.stop="scrollTop"
                        >
                            <v-icon large>keyboard_arrow_up</v-icon>
                        </v-btn>
                    </transition>    
                    <router-view></router-view>
                
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import MainNav from './components/navigation/MainNav.vue';
import MessageBar from './components/messagebar/MessageBar.vue'

export default {
    name: 'App',
    
    components: {
        'main-nav': MainNav,
        'message-bar':MessageBar
    },
    data () {
        return {
            offsetTop:0
        }
    },
    computed: {
        ...mapGetters({
            isAuth: 'auth/isAuth',            
            menuItems: 'menuItems',                
        })
    },
    methods: {
        onLogout: function() {
            this.$store.commit('search/SEARCH_SET_SHOW',false)            
            this.$dmAuth.killToken();
            this.$store.commit('auth/AUTH_KILL_USER')
            this.$store.commit('auth/AUTH_SET_AUTH')
            window.localStorage.clear();
            this.$router.push('/login')                      
        },
        onScroll: function(e) {
            e
            this.offsetTop = window.pageYOffset || document.documentElement.scrollTop
        },
        
        scrollTop: function() {
            var scrollStep = -window.scrollY / (300 / 15),
            scrollInterval = setInterval(function(){
            if ( window.scrollY != 0 ) {
                window.scrollBy( 0, scrollStep );
            }
            else clearInterval(scrollInterval); 
            },15);
        }
        
        
    }
}
</script>
<style lang="stylus">
  @require './stylus/main'
  
</style>